export default Object.freeze({
  CHAT_DROPZONE_ACCEPTED_FILES: "image/*,application/pdf",
  MAX_FILE_SIZE: 5 * 1024 * 1024,
  TIMESTAMP: 30 * 60 * 1000,
});

export const navHeight = 8;
export const navHeightPx = "64px";
export const navAndBottomHeightPx = "120px";
export const bottomHeight = 75;

export const STORYLANE_VIDEO_LINKS = {
  inbox: "mi4dg9ccnnww",
  calendar: "ocwfb8o1aunm",
  report: "xyg3lmz0m0ct",
  task: "sbigaidi68lm",
  settings: "j0q38qey96ld",
  cartelligent: "xlf67snertil",
  autoMarketing: "r9eip2crsi33",
  reviewMax: "mdtnumd3arim",
};
